<template>
  <div style="padding: 0 10px;">
    <b-tabs active-nav-item-class="font-weight-bold text-light bg-success mt-1">
      
      <!-- 1. KELDI-KETDI TAB -->
      <b-tab title="Келди-кетди" @click="getData" title-link-class="mr-1 text-primary font-weight-bold"
        style="padding: 0px !important;">
        <div class="tek-card">
          <div style="padding: 10px 0; display: flex;">
            <input style="width: 170px; margin-right: 10px;" class="form-control" type="date" v-model="date" />
            <b-button class="qoshishBtn" variant="primary" @click="getData">
              <span>{{ $t("Кўриш") }}</span>
            </b-button>
            <!-- Excel Button -->
            <b-button class="qoshishBtn ml-2" variant="success" @click="downloadKeldiKetdi" style="margin-left: 10px;">
              <b-icon icon="file-earmark-excel"></b-icon> <span>Ехcел</span>
            </b-button>
          </div>
          <div class="table-scrol">
            <table class="table table-sm table-striped">
              <tr class="bg-dark text-white">
                <th>№</th>
                <th>{{ "Ходим" }}</th>
                <th>{{ "Келиш вақти" }}</th>
                <th>{{ "Кетиш вақти" }}</th>
                <th>{{ "Келди - Кетди" }}</th>
              </tr>
              <tr v-for="(item, index) in items" :key="index" v-on:dblclick="Clicked(item)"
                :class="!item.real_come_time ? 'red_class' : ''">
                <td>{{ index + 1 }}</td>
                <td>{{ item.user_name }}</td>
                <td>{{ item.come_time }}</td>
                <td>{{ item.leave_time }}</td>
                <td style="font-size: 14pt;">
                  <b-badge v-if="item.come" pill variant="danger">{{ item.real_come_time | dateFormatDD }}</b-badge>
                  <b-badge v-else pill variant="success">{{ item.real_come_time | dateFormatDD }}</b-badge>
                  <b-badge v-if="item.leave" pill variant="danger">{{ item.real_leave_time | dateFormatDD }}</b-badge>
                  <b-badge v-else pill variant="success">{{ item.real_leave_time | dateFormatDD }}</b-badge>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </b-tab>

      <!-- 2. DAVOMAT TAB -->
      <b-tab title="Давомат" @click="getDavomat" title-link-class="mr-1 text-primary font-weight-bold"
        style="padding: 0px !important;">
        <div class="tek-card">
          <div style="padding: 10px 0; display: flex;">
            <input style="width: 170px; margin-right: 10px;" class="form-control" type="date" v-model="date1" />
            <input style="width: 170px; margin-right: 10px;" class="form-control" type="date" v-model="date2" />
            <b-button class="qoshishBtn" variant="primary" @click="getDavomat">
              <span>{{ $t("Кўриш") }}</span>
            </b-button>
            <!-- Excel Button -->
            <b-button class="qoshishBtn ml-2" variant="success" @click="downloadDavomat" style="margin-left: 10px;">
              <span>Ехcел</span>
            </b-button>
          </div>
        </div>
        <div>
          <table border="1px solid black" class="shablo_table">
            <thead style="text-align: center;">
              <tr>
                <th style="width: 200px;">Izoh</th>
                <th v-for="item in days" style="width: 80px !important;" :key="item">
                  <div class="card_month">
                    {{ item | dateFormatDay }}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style="height: 30px;" v-for="(item, index) in davomat" :key="index">
                <td>{{ item.user_name }}</td>
                <td v-for="(day, dIndex) in days" :key="dIndex">
                  <span style="font-size: 12px;">
                    {{ getDavomadForuser(day, days[dIndex + 1] || day + 86400000, item) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>

      <!-- 3. JARIMALAR TAB -->
      <b-tab title="Жарималар" @click="getDavomat" title-link-class="mr-1 text-primary font-weight-bold"
        style="padding: 0px !important;">
        <div class="tek-card">
          <div style="padding: 10px 0; display: flex;">
            <input style="width: 170px; margin-right: 10px;" class="form-control" type="date" v-model="date1" />
            <input style="width: 170px; margin-right: 10px;" class="form-control" type="date" v-model="date2" />
            <b-button class="qoshishBtn" variant="primary" @click="getJarima">
              <span>{{ $t("Кўриш") }}</span>
            </b-button>
            <!-- Excel Button -->
            <b-button class="qoshishBtn ml-2" variant="success" @click="downloadJarima" style="margin-left: 10px;">
              <span>Ехcел</span>
            </b-button>
          </div>
        </div>
        <div>
          <table border="1px solid black" class="shablo_table">
            <thead style="text-align: center;">
              <tr>
                <th style="width: 200px;">Izoh</th>
                <th v-for="item in days" style="width: 80px !important;" :key="item">
                  <div class="card_month">
                    {{ item | dateFormatDay }}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style="height: 30px;" v-for="(item, index) in jarima" :key="index">
                <td>{{ item.user_name }}</td>
                <td v-for="(day, dIndex) in days" :key="dIndex">
                  <span :style="getJarimaForuser(day, days[dIndex + 1] || day + 86400000, item.user_faceid) ? 'background: red;  color:#fff;' : ''">
                    {{ getJarimaForuser(day, days[dIndex + 1] || day + 86400000, item.user_faceid) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>

      <!-- 4. OYLIK TAB -->
      <b-tab title="Ойлик ва жарималар" @click="getDavomat" title-link-class="mr-1 text-primary font-weight-bold"
        style="padding: 0px !important;">
        <div class="tek-card">
          <div style="padding: 10px 0; display: flex;">
            <input style="width: 170px; margin-right: 10px;" class="form-control" type="date" v-model="date1" />
            <input style="width: 170px; margin-right: 10px;" class="form-control" type="date" v-model="date2" />
            <b-button class="qoshishBtn" variant="primary" @click="getOylik">
              <span>{{ $t("Кўриш") }}</span>
            </b-button>
            <!-- Excel Button -->
            <b-button class="qoshishBtn ml-2" variant="success" @click="downloadOylik" style="margin-left: 10px;">
              <span>Ехcел</span>
            </b-button>
          </div>
        </div>
        <div>
          <table border="1px solid black" class="shablo_table">
            <thead style="text-align: center;">
              <tr>
                <th style="width: 200px;">Исм</th>
                <th style="width: 300px;">Жарима</th>
                <th style="width: 300px;">Ойлик</th>
                <th style="width: 300px;">Якуний</th>
                <th style="width: 300px;">Батафсил</th>
              </tr>
            </thead>
            <tbody>
              <tr style="height: 30px;" v-for="(item, index) in oylik" :key="index">
                <td>{{ item.user_name }}</td>
                <td style="background-color: red; color: #fff;">{{ item.jami_jarima }}</td>
                <td style="background-color: forestgreen; color: #fff;">{{ item.salary }}</td>
                <td style="background-color:#3ae32b; color: #fff;">{{ item.yakuniy_oylik }} </td>
                <td>
                  <b-button v-b-modal="'modal-lg' + index" class="qoshishBtn" variant="primary" style="margin: auto;">
                    <span>{{ $t("Кўриш") }}</span>
                  </b-button>
                  <b-modal :id="'modal-lg' + index" size="lg" title="Жарималар рўйхати" hide-footer>
                    <div v-if="item.user_faceid.length < 1" style="margin: auto; text-align: center;">
                       <span class="text-muted">Маълумот йўқ</span>
                    </div>
                    <div v-for="(entry, eIndex) in item.user_faceid" :key="eIndex">
                      <div v-if="entry.user_faceid_child && entry.user_faceid_child.length">
                        <table border="1px solid black" style="width: 100%; margin-bottom: 10px;">
                          <tr>
                            <th>ID</th>
                            <th>Sabab</th>
                            <th>Vaqt</th>
                            <th>Summa</th>
                          </tr>
                          <tr v-for="(child, childIndex) in entry.user_faceid_child" :key="childIndex">
                            <td style="text-align: center;"> {{ child.id }}</td>
                            <td style="text-align: center;">
                              <span v-if="child.type == 'come'">Кеч келгани учун</span>
                              <span v-if="child.type == 'leave'">Эрта кетгани учун</span>
                            </td>
                            <td style="text-align: center;">{{ formatTimestamp(child.datetime) }}</td>
                            <td style="text-align: center;"> {{ child.price }}</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </b-modal>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import moment from 'moment';
import * as XLSX from 'xlsx'; // Import sheetjs

export default {
  name: "UserIndex",
  components: {},
  data() {
    return {
      items: [],
      davomat: [],
      oylik: [],
      jarima: [],
      jarimaList: [],
      date: new Date().toISOString().slice(0, 10),
      date1: new Date().toISOString().slice(0, 8) + "01",
      date2: new Date().toISOString().slice(0, 10),
      user_id: null,
      days: [],
    };
  },
  filters: {
    dateFormatDD: function (date) {
      if (date) {
        return moment(new Date(date * 1000)).format("DD.MM.YYYY HH:mm");
      } else {
        return "";
      }
    },
    dateFormatDay: function (date) {
      if (date) {
        return moment(new Date(date)).format("DD");
      } else {
        return "";
      }
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatTimestamp(timestamp) {
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },

    getData() {
      let self = this;
      self.davomat = []
      axios({
        method: "post",
        url: "/hisobot/user_faceid",
        data: {
          date: self.date
        }
      }).then(res => {
        if (res) {
          self.items = res.data.data;
        }
      });
    },

    getDaysBetween(date1, date2) {
      let startDate = new Date(date1.slice(0, 10));
      let endDate = new Date(date2.slice(0, 10));
      let days = [];

      while (startDate <= endDate) {
        days.push(startDate.getTime());
        startDate.setDate(startDate.getDate() + 1);
      }
      return days;
    },

    getJarimaForuser(timestamp, timestamp2, face) {
      let d1 = Math.floor(timestamp / 1000)
      let d2 = Math.floor(timestamp2 / 1000)
      
      if (!face || !Array.isArray(face)) return '';

      let arr = []
      for (let i = 0; i < face.length; i++) {
         if (face[i].user_faceid_child && Array.isArray(face[i].user_faceid_child)) {
             const element = face[i].user_faceid_child.filter(k => k.datetime > d1 && k.datetime <= d2);
             arr = arr.concat(element)
         }
      }
      const total = arr.reduce((total, item) => total += item.price || 0, 0);
      return total ? total.toLocaleString('ru-RU') : '';
    },

    getDavomadForuser(timestamp, timestamp2, item) {
      const d1 = Math.floor(timestamp / 1000);
      const d2 = Math.floor(timestamp2 / 1000);

      if (!item || !Array.isArray(item.user_faceid)) return '-';

      let totalSeconds = 0;

      for (const record of item.user_faceid) {
        const come = record.real_come_time;
        const leave = record.real_leave_time;

        if (come && leave && come >= d1 && come <= d2) {
          totalSeconds += leave - come;
        }
      }

      if (totalSeconds === 0) return '-';

      const totalMinutes = Math.floor(totalSeconds / 60);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      return `${hours}:${minutes.toString().padStart(2, '0')} m`;
    },

    getDavomat() {
      let self = this;
      self.davomat = [];
      self.days = self.getDaysBetween(self.date1, self.date2)
      let datas = {
        date1: self.date1,
        date2: self.date2,
        user_id: self.user_id
      }
      axios({
        method: "post",
        url: "/hisobot/davomat",
        data: datas
      }).then(res => {
        if (res) {
          self.davomat = res.data.data;
        }
      });
    },

    getJarima() {
      let self = this;
      self.jarima = [];
      self.days = self.getDaysBetween(self.date1, self.date2)
      let datas = {
        date1: self.date1,
        date2: self.date2,
        user_id: self.user_id
      }
      axios({
        method: "post",
        url: "/hisobot/jarima",
        data: datas
      }).then(res => {
        if (res) {
          self.jarima = res.data.data;
        }
      });
    },

    getOylik() {
      let self = this;
      self.oylik = [];
      self.days = self.getDaysBetween(self.date1, self.date2);
      let datas = {
        date1: self.date1,
        date2: self.date2,
        user_id: self.user_id
      };

      axios({
        method: "post",
        url: "/hisobot/oylik",
        data: datas
      }).then(res => {
        if (res && res.data && Array.isArray(res.data.data)) {
          let result = res.data.data.map(user => {
            let jami_jarima = 0;
            if(user.user_faceid && Array.isArray(user.user_faceid)){
                user.user_faceid.forEach(face => {
                if (Array.isArray(face.user_faceid_child)) {
                    face.user_faceid_child.forEach(child => {
                    jami_jarima += child.price || 0;
                    });
                }
                });
            }

            let yakuniy_oylik = (user.salary || 0) - jami_jarima;

            user.jami_jarima = jami_jarima.toLocaleString('ru-RU');
            user.yakuniy_oylik = yakuniy_oylik.toLocaleString('ru-RU');

            return user;
          });

          self.oylik = result;
        }
      });
    },

    // --- EXCEL EXPORT FUNCTIONS (WIDTH FIXED) --- //

    // 1. Keldi-Ketdi Excel
    downloadKeldiKetdi() {
      if (!this.items || this.items.length === 0) {
        alert("Ma'lumot yo'q!");
        return;
      }
      
      const dataForExcel = this.items.map((item, index) => ({
        "№": index + 1,
        "Ходим": item.user_name,
        "Жадвал бўйича келиш": item.come_time,
        "Жадвал бўйича кетиш": item.leave_time,
        "Келиш вақти": item.real_come_time ? moment(item.real_come_time * 1000).format("DD.MM.YYYY HH:mm") : "",
        "Кетиш вақти": item.real_leave_time ? moment(item.real_leave_time * 1000).format("DD.MM.YYYY HH:mm") : "",
      }));

      const ws = XLSX.utils.json_to_sheet(dataForExcel);

      // Ustun kengligini sozlash
      ws['!cols'] = [
        { wch: 5 },  // №
        { wch: 30 }, // Ходим
        { wch: 22 }, // Jadval kelish
        { wch: 22 }, // Jadval ketish
        { wch: 22 }, // Haqiqiy kelish
        { wch: 22 }  // Haqiqiy ketish
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Keldi-Ketdi");
      XLSX.writeFile(wb, `Keldi_Ketdi_${this.date}.xlsx`);
    },

    // 2. Davomat Excel (Dinamik)
    downloadDavomat() {
      if (!this.davomat || this.davomat.length === 0) {
        alert("Ma'lumot yo'q yoki avval 'Ko'rish' tugmasini bosing!");
        return;
      }

      let headerRow = ["F.I.O"];
      this.days.forEach(day => {
        headerRow.push(moment(day).format("DD.MM"));
      });

      let bodyRows = this.davomat.map(user => {
        let row = [user.user_name];
        this.days.forEach((day, i) => {
          let nextDay = this.days[i + 1] || day + 86400000;
          let val = this.getDavomadForuser(day, nextDay, user);
          row.push(val);
        });
        return row;
      });

      const finalData = [headerRow, ...bodyRows];
      const ws = XLSX.utils.aoa_to_sheet(finalData);

      // Dinamik ustun kengligini sozlash
      const wscols = [
        { wch: 35 } // F.I.O ustuni
      ];
      // Har bir kun uchun
      this.days.forEach(() => {
        wscols.push({ wch: 10 });
      });
      ws['!cols'] = wscols;

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Davomat");
      XLSX.writeFile(wb, `Davomat_${this.date1}_${this.date2}.xlsx`);
    },

    // 3. Jarimalar Excel (Dinamik)
    downloadJarima() {
      if (!this.jarima || this.jarima.length === 0) {
        alert("Ma'lumot yo'q yoki avval 'Ko'rish' tugmasini bosing!");
        return;
      }

      let headerRow = ["F.I.O"];
      this.days.forEach(day => {
        headerRow.push(moment(day).format("DD.MM"));
      });

      let bodyRows = this.jarima.map(user => {
        let row = [user.user_name];
        this.days.forEach((day, i) => {
          let nextDay = this.days[i + 1] || day + 86400000;
          let val = this.getJarimaForuser(day, nextDay, user.user_faceid);
          row.push(val); 
        });
        return row;
      });

      const finalData = [headerRow, ...bodyRows];
      const ws = XLSX.utils.aoa_to_sheet(finalData);

      // Dinamik ustun kengligini sozlash
      const wscols = [
        { wch: 40 } // F.I.O
      ];
      // Har bir kun uchun
      this.days.forEach(() => {
        wscols.push({ wch: 12 });
      });
      ws['!cols'] = wscols;

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Jarimalar");
      XLSX.writeFile(wb, `Jarima_${this.date1}_${this.date2}.xlsx`);
    },

    // 4. Oylik Excel
    downloadOylik() {
      if (!this.oylik || this.oylik.length === 0) {
        alert("Ma'lumot yo'q yoki avval 'Ko'rish' tugmasini bosing!");
        return;
      }

      const dataForExcel = this.oylik.map((item, index) => ({
        "№": index + 1,
        "Ф.И.О": item.user_name,
        "Жами Жарима": item.jami_jarima,
        "Ойлик Маош": item.salary ? item.salary.toLocaleString('ru-RU') : 0,
        "Якуний Ойлик": item.yakuniy_oylik
      }));

      const ws = XLSX.utils.json_to_sheet(dataForExcel);

      // Ustun kengligini sozlash
      ws['!cols'] = [
        { wch: 5 },  // №
        { wch: 40 }, // F.I.O
        { wch: 20 }, // Jarima
        { wch: 20 }, // Oylik
        { wch: 20 }  // Yakuniy
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Oylik");
      XLSX.writeFile(wb, `Oylik_${this.date1}_${this.date2}.xlsx`);
    }

  },
};
</script>

<style scoped>
.tek-card {
  border: 1px solid #ccc;
  border-radius: 10px;
  min-height: 0px;
  background: #fff;
  padding: 10px;
}

.red_class {
  background-color: #ff5858;
  color: #fff;
}

.table-scrol {
  width: 100%;
  height: calc(100vh - 235px);
  overflow: auto;
}

#table {
  width: 99% !important;
}

.table {
  margin: 0px 0px !important;
}

label,
td,
th,
tr {
  font-weight: 500;
  font-size: 13pt;
  height: 30px !important;
  text-align: center;
}

.reds {
  color: red;
}

th {
  color: #195fb0;
  background-color: #f4f7fb;
}

.qoshishBtn {
  display: flex;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
}
</style>